﻿<script setup lang="ts">
    import ModalBase from '@/shared/components/ModalBase.vue';
    import {
        PlanProjectReferenceCount,
        PlanProjectProjectMasterIntersection,
        ProjectMasterCode
    } from '@/apps/facilityAndProject/ProjectMaster.helper.ts';
    import { computed, ref } from 'vue';

    type Props = {
        planProject: PlanProjectReferenceCount;
        projectMaster: ProjectMasterCode;
        attributes: (keyof PlanProjectProjectMasterIntersection)[];
    };

    type Emits = {
        onCancel: [void];
        onConfirm: [attributesToCopy: (keyof PlanProjectProjectMasterIntersection)[]];
    };

    type TableRow = {
        attributeName: keyof PlanProjectProjectMasterIntersection;
        projectMaster: string;
        planProject: string;
    };

    const props = defineProps<Props>();
    const emits = defineEmits<Emits>();

    const columns = [
        {
            field: 'attributeName',
            label: 'Attribute'
        },
        {
            field: 'projectMaster',
            label: 'Current value'
        },
        {
            field: 'planProject',
            label: 'Plan project\'s value'
        }
    ];

    const attrTableData = computed((): TableRow[] => {
        return props.attributes.map((attr) => {
            return {
                attributeName: attr,
                projectMaster: String(props.projectMaster[attr] ?? ''),
                planProject: String(props.planProject[attr] ?? '')
            };
        });
    });

    // select all as default
    const selectedAttributes = ref<TableRow[]>(attrTableData.value);

    function selectedAttributeNames(): (keyof PlanProjectProjectMasterIntersection)[] {
        return selectedAttributes.value.map((attr) => attr.attributeName);
    }

    function onConfirm(): void {
        emits('onConfirm', selectedAttributeNames());
    }

    function onClose(): void {
        emits('onCancel');
    }

</script>

<template>
    <modal-base @onCancel="onClose">
        <template #modal-header>
            Select values to copy from plan project
        </template>
        <template #modal-body>
            <b-table
                v-model:checked-rows="selectedAttributes"
                :data="attrTableData"
                :columns="columns"
                checkbox-position="right"
                checkable />
        </template>
        <template #modal-footer>
            <b-button
                label="Cancel"
                @click="onClose" />
            <b-button
                label="Confirm"
                type="is-primary"
                @click="onConfirm" />
        </template>
    </modal-base>
</template>

<style scoped>

</style>
